define("Transaction.Line.Views.Cell.Actionable.View.Extension", [
  "Transaction.Line.Views.Cell.Actionable.View",
  "underscore",
  "jQuery",
  "Item.Model",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "LiveOrder.Model",
  "Ames.RentFromAnywhere.RequestRentalExtension.View",
  "Ames.RentFromAnywhere.RentalLine",
], function (
  TransactionLineViewsCellActionableView,
  _,
  jQuery,
  ItemModel,
  RentFromAnywhereSS2Model,
  LiveOrderModel,
  AmesRentFromAnywhereRequestRentalExtensionView,
  RentalLine
) {
  "use strict";

  // Inject popup styles once into <head> so they're always available globally
  if (!document.getElementById('ames-lost-tool-popup-styles')) {
    var styleEl = document.createElement('style');
    styleEl.id = 'ames-lost-tool-popup-styles';
    styleEl.textContent =
      '.return-label-overlay {' +
        'position: fixed;' +
        'top: 0;' +
        'left: 0;' +
        'width: 100%;' +
        'height: 100%;' +
        'background: rgba(0, 0, 0, 0.5);' +
        'z-index: 10000;' +
      '}' +
      '.return-label-popup {' +
        'position: fixed;' +
        'top: 50%;' +
        'left: 50%;' +
        'transform: translate(-50%, -50%);' +
        'z-index: 10001;' +
        'background: #fff;' +
        'border-radius: 8px;' +
        'width: 90%;' +
        'max-width: 420px;' +
        'box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);' +
        'overflow: hidden;' +
        'font-family: inherit;' +
      '}' +
      '.return-label-popup-header {' +
        'display: flex;' +
        'justify-content: space-between;' +
        'align-items: center;' +
        'padding: 16px 20px;' +
        'border-bottom: 1px solid #e5e5e5;' +
      '}' +
      '.return-label-popup-header span {' +
        'font-size: 18px;' +
        'font-weight: 600;' +
        'color: #333;' +
      '}' +
      '.return-label-popup-close {' +
        'background: none;' +
        'border: none;' +
        'font-size: 22px;' +
        'color: #999;' +
        'cursor: pointer;' +
        'padding: 0;' +
        'line-height: 1;' +
      '}' +
      '.return-label-popup-close:hover {' +
        'color: #333;' +
      '}' +
      '.return-label-popup-body {' +
        'padding: 20px;' +
      '}' +
      '.return-label-popup-body p {' +
        'margin: 0 0 14px;' +
        'font-size: 14px;' +
        'color: #555;' +
        'line-height: 1.5;' +
      '}' +
      '.return-label-popup-detail {' +
        'background: #f7f7f7;' +
        'border: 1px solid #eee;' +
        'border-radius: 4px;' +
        'padding: 10px 14px;' +
        'font-size: 13px;' +
        'color: #555;' +
      '}' +
      '.return-label-popup-footer {' +
        'display: flex;' +
        'justify-content: flex-end;' +
        'gap: 10px;' +
        'padding: 14px 20px;' +
        'border-top: 1px solid #e5e5e5;' +
        'background: #fafafa;' +
      '}' +
      '.return-label-popup-btn {' +
        'padding: 8px 20px;' +
        'border-radius: 4px;' +
        'font-size: 14px;' +
        'font-weight: 500;' +
        'cursor: pointer;' +
        'border: 1px solid transparent;' +
      '}' +
      '.return-label-popup-btn:disabled {' +
        'opacity: 0.6;' +
        'cursor: not-allowed;' +
      '}' +
      '.return-label-popup-btn-no {' +
        'background: #fff;' +
        'border-color: #ccc;' +
        'color: #555;' +
      '}' +
      '.return-label-popup-btn-no:hover:not(:disabled) {' +
        'background: #f0f0f0;' +
      '}' +
      '.return-label-popup-btn-yes {' +
        'background: #337ab7;' +
        'color: #fff;' +
      '}' +
      '.return-label-popup-btn-yes:hover:not(:disabled) {' +
        'background: #286090;' +
      '}' +
      '.notify-lost-tool-header span {' +
        'color: #d9534f;' +
      '}' +
      '.notify-lost-tool-warning {' +
        'display: flex;' +
        'align-items: flex-start;' +
        'gap: 10px;' +
        'background: #fff8e1;' +
        'border: 1px solid #ffe082;' +
        'border-radius: 6px;' +
        'padding: 14px 16px;' +
        'margin-bottom: 14px;' +
      '}' +
      '.notify-lost-tool-warning span {' +
        'font-size: 14px;' +
        'color: #6d5b00;' +
        'line-height: 1.5;' +
      '}' +
      '.notify-lost-tool-warning-icon {' +
        'font-size: 20px !important;' +
        'flex-shrink: 0;' +
        'margin-top: 1px;' +
      '}' +
      '.notify-lost-tool-confirm-text {' +
        'font-weight: 500;' +
        'color: #333 !important;' +
        'margin-bottom: 0 !important;' +
      '}' +
      '.notify-lost-tool-btn-yes {' +
        'background: #d9534f !important;' +
        'color: #fff !important;' +
        'border-color: #d43f3a !important;' +
      '}' +
      '.notify-lost-tool-btn-yes:hover:not(:disabled) {' +
        'background: #c9302c !important;' +
      '}' +
      '.return-label-result-header-success span {' +
        'color: #3c763d;' +
      '}' +
      '.return-label-result-header-error span {' +
        'color: #a94442;' +
      '}';
    document.head.appendChild(styleEl);
  }

  _.extend(TransactionLineViewsCellActionableView.prototype, {
    initialize: _.wrap(
      TransactionLineViewsCellActionableView.prototype.initialize,
      function (fn) {
        fn.apply(this, _.toArray(arguments).slice(1));
        this.rentFromAnywhereModel = new RentFromAnywhereSS2Model();
        this.orderId = this.model.id;
        this.itemId = this.model.get("item").id;
        this.layout = this.options.application.getLayout();
        this.isRentalExpired = false;
        this.status = null;
        this.hasOpenRma = false;
        this.applyOpenRmaStatus = null;
        this.fulfillmentIdForLabelCreation = null;
        this.sameFulfillmentRecord = false;
        this.enableLabelCreation = false;
        this.downloadFileUrl = null;
        this.notifyLostTool = false;
        this.lostTool = false;
        this.isRentalClosed = false;

        var self = this;

        if (this.orderId && this.orderId.indexOf("_") > -1) {
          this.orderId = this.orderId.split("_")[0];
        }
        var index = this.model.get("index");
        // Shared strict rule: custcol_custom_rate / "N Days Rental" / a NetScore
        // rate column > 0. A configurable set line never matches.
        this.isRental = RentalLine.isRentalLine(this.model);

        this.rentalEndDate = null;
        this.lineIndex = index - 1;

        if (this.isRental) {
          // fast path: the line columns say it is a rental line
          this.loadRentalLine();
          return;
        }

        // Fallback: the line columns were not exposed / were cleared (NetScore
        // re-saves the rental order and can drop custcol_configurable_description).
        // A NetScore rental order only ever holds rental lines, so if the ORDER
        // is a rental order (one cached service call per order) treat this line
        // as a rental line too.
        RentFromAnywhereSS2Model.orderInfo(this.orderId).done(function (info) {
          if (!info) return;
          self.isRental = true;
          self.render();
          self.loadRentalLine();
        });
      }
    ),

    // Per-line rental details (status, RMA, return label, replacement request)
    loadRentalLine: function () {
        var self = this;
        this.rentFromAnywhereModel
          .fetch({
            data: {
              orderId: this.orderId,
              index: this.lineIndex,
            },
          })
          .done(function (response) {
            if (response.isClosed) {
              self.isRentalClosed = true; 
              self.render();
            }
            if (response && response.success && response.rental_end_date) {
              var date = new Date(response.rental_end_date);
              self.status = response.orderStatus;
              self.hasOpenRma = response.hasOpenRma;
              self.rmaDetails = null;
              // manual replacement flow: request logged on the SO, swap done by hand
              self.replacementRequest = response.replacementRequest || null;
              var returnLabel = response.returnLabel;
              var url = new URL(window.location.href).origin;
              if (returnLabel && returnLabel.fileUrl) {
                self.downloadFileUrl = url + returnLabel.fileUrl;
              }

              if (
                self.hasOpenRma &&
                response.rmaRecords &&
                response.rmaRecords.length > 0
              ) {
                var rma = response.rmaRecords[0];
                self.rmaDetails = {
                  id: rma.id,
                  tranid: rma.tranid,
                  trandate: rma.trandate,
                  status: rma.status,
                  statusId: rma.statusId,
                  isReplaced: rma.isReplaced,
                  repWith: rma.repWith,
                  repFrom: rma.repFrom,
                  quantity: rma.quantity,
                };
              }

              if (response.isLost) {
                self.lostTool = true;
              }

              var month = (date.getMonth() + 1).toString().padStart(2, "0");
              var day = date.getDate().toString().padStart(2, "0");
              var year = date.getFullYear();

              self.rentalEndDate = month + "/" + day + "/" + year;

              var today = new Date();
              today.setHours(0, 0, 0, 0);
              date.setHours(0, 0, 0, 0);

              self.isRentalExpired = date < today && self.status !== "4";
              self.sameFulfillmentRecord = response.sameFulfillmentRecord;
              self.fulfillmentIdForLabelCreation = response.fulfillRecordId;
              if (!self.sameFulfillmentRecord && self.fulfillmentIdForLabelCreation && self.isRentalExpired && !self.hasOpenRma && !self.replacementRequest) {
                self.enableLabelCreation = true;
              }

              if (!self.hasOpenRma && !self.replacementRequest && !self.lostTool && self.status === "3") {
                self.notifyLostTool = true;
              }

              self.render();
            }
          });
    },
    events: {
      'click [data-action="request-rental-replacement"]': "requestRentalReplacement",
      'click [data-action="create-return-label"]': "createReturnLabel",
      'click [data-action="notify-lost-tool"]': "notifyLostToolAction"
    },
    notifyLostToolAction: function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Guard: if a popup is already open, do nothing
      if (jQuery('.return-label-overlay').length > 0) {
        return;
      }

      var self = this;
      var itemName = this.model.get("item").get("_name") || "this item";

      var $overlay = jQuery('<div class="return-label-overlay"></div>');
      var $popup = jQuery(
        '<div class="return-label-popup">' +
          '<div class="return-label-popup-header notify-lost-tool-header">' +
            '<span>Report Lost Tool</span>' +
            '<button class="return-label-popup-close" data-action="close-popup">&times;</button>' +
          '</div>' +
          '<div class="return-label-popup-body">' +
            '<p>You are about to report <strong>' + _.escape(itemName) + '</strong> as lost.</p>' +
            '<div class="notify-lost-tool-warning">' +
              '<span class="notify-lost-tool-warning-icon">&#9888;</span>' +
              '<span>Our warehouse team will be notified immediately. Please note that <strong>charges may apply</strong> based on the duration of the rental period for this tool.</span>' +
            '</div>' +
            '<p class="notify-lost-tool-confirm-text">Do you wish to proceed?</p>' +
          '</div>' +
          '<div class="return-label-popup-footer">' +
            '<button class="return-label-popup-btn return-label-popup-btn-no" data-action="close-popup">Cancel</button>' +
            '<button class="return-label-popup-btn notify-lost-tool-btn-yes">Yes, Notify Warehouse</button>' +
          '</div>' +
        '</div>'
      );

      jQuery("body").append($overlay).append($popup);

      function closePopup() {
        $overlay.remove();
        $popup.remove();
      }

      $overlay.on("click", closePopup);
      $popup.on("click", '[data-action="close-popup"]', closePopup);

      $popup.find(".notify-lost-tool-btn-yes").on("click", function () {
        var $btn = jQuery(this);
        $btn.prop("disabled", true).text("Submitting...");
        $popup.find(".return-label-popup-btn-no").prop("disabled", true);
        $popup.find(".return-label-popup-close").prop("disabled", true);

        var suiteletUrl = '/app/site/hosting/scriptlet.nl' +
          '?script=customscript_rental_return_label_sl' +
          '&deploy=customdeploy_rental_return_label_sl' +
          '&orderId=' + encodeURIComponent(self.orderId) +
          '&index=' + encodeURIComponent(self.lineIndex) +
          '&notifyLost=true';

        jQuery.ajax({
          url: suiteletUrl,
          type: 'GET',
          dataType: 'json'
        }).done(function (response) {
          closePopup();
          if (response && response.success) {
            self._showResultPopup('success', 'Lost Tool Reported', response.message || 'The warehouse has been notified. You may be contacted regarding applicable charges.');
          } else {
            self._showResultPopup('error', 'Submission Failed', response && response.message ? response.message : 'An unknown error occurred.');
          }
        }).fail(function (jqXHR, textStatus) {
          closePopup();
          self._showResultPopup('error', 'Request Failed', 'Could not reach the server. Please try again. (' + textStatus + ')');
        });
      });
    },
    requestRentalReplacement: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var view = new AmesRentFromAnywhereRequestRentalExtensionView({
        orderId: this.orderId,
        itemId: this.itemId,
        returningDate: this.rentalEndDate,
        quantityavailable: this.model.get("quantity"),
        index: this.model.get("index") - 1,
      });
      this.layout.showInModal(view);
    },
    createReturnLabel: function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Guard: if a popup is already open, do nothing
      if (jQuery('.return-label-overlay').length > 0) {
        return;
      }

      var self = this;
      var itemName = this.model.get("item").get("_name") || "this item";
      var fulfillmentId = this.fulfillmentIdForLabelCreation;
      var todaysDate = new Date();
      var month = (todaysDate.getMonth() + 1).toString().padStart(2, "0");
      var day = todaysDate.getDate().toString().padStart(2, "0");
      var year = todaysDate.getFullYear();
      var formattedDate = month + "/" + day + "/" + year;

      if (!fulfillmentId) {
        return;
      }

      var $overlay = jQuery('<div class="return-label-overlay"></div>');
      var $popup = jQuery(
        '<div class="return-label-popup">' +
          '<div class="return-label-popup-header">' +
            '<span>Create Return Label</span>' +
            '<button class="return-label-popup-close" data-action="close-popup">&times;</button>' +
          '</div>' +
          '<div class="return-label-popup-body">' +
            '<p>Create a return shipping label for <strong>' + _.escape(itemName) + '</strong>?</p>' +
            '<div class="return-label-popup-detail">' +
              '<span>Due Date: <strong>' + _.escape(formattedDate || 'N/A') + '</strong></span>' +
            '</div>' +
          '</div>' +
          '<div class="return-label-popup-footer">' +
            '<button class="return-label-popup-btn return-label-popup-btn-no" data-action="close-popup">No</button>' +
            '<button class="return-label-popup-btn return-label-popup-btn-yes">Yes, Create Label</button>' +
          '</div>' +
        '</div>'
      );

      jQuery("body").append($overlay).append($popup);

      function closePopup() {
        $overlay.remove();
        $popup.remove();
      }

      $overlay.on("click", closePopup);
      $popup.on("click", '[data-action="close-popup"]', closePopup);

      $popup.find(".return-label-popup-btn-yes").on("click", function () {
        var $btn = jQuery(this);
        $btn.prop("disabled", true).text("Creating...");
        $popup.find(".return-label-popup-btn-no").prop("disabled", true);
        $popup.find(".return-label-popup-close").prop("disabled", true);

        var suiteletUrl = '/app/site/hosting/scriptlet.nl' +
          '?script=customscript_rental_return_label_sl' +
          '&deploy=customdeploy_rental_return_label_sl' +
          '&rentalFulfillmentId=' + encodeURIComponent(fulfillmentId) +
          '&createdFromWeb=true' +
          '&index=' + encodeURIComponent(self.lineIndex);

        jQuery.ajax({
          url: suiteletUrl,
          type: 'GET',
          dataType: 'json'
        }).done(function (response) {
          closePopup();
          if (response && response.success) {
            if (response.labels && response.labels.length > 0) {
              for (var i = 0; i < response.labels.length; i++) {
                if (response.labels[i].fileUrl) {
                  window.open('https://shopamestools.com' + response.labels[i].fileUrl, '_blank');
                }
              }
            }
            self._showResultPopup('success', 'Return Label Created', response.message || 'Label created successfully.');
          } else {
            self._showResultPopup('error', 'Label Creation Failed', response && response.message ? response.message : 'An unknown error occurred.');
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          closePopup();
          self._showResultPopup('error', 'Request Failed', 'Could not reach the server. Please try again. (' + textStatus + ')');
        });
      });
    },
    _showResultPopup: function (type, title, message) {
      jQuery('.return-label-overlay').remove();
      jQuery('.return-label-popup').remove();

      var isSuccess = type === 'success';
      var headerClass = isSuccess ? 'return-label-result-header-success' : 'return-label-result-header-error';
      var icon = isSuccess ? '&#10003;' : '&#10007;';

      var $overlay = jQuery('<div class="return-label-overlay"></div>');
      var $popup = jQuery(
        '<div class="return-label-popup">' +
          '<div class="return-label-popup-header ' + headerClass + '">' +
            '<span>' + icon + ' ' + _.escape(title) + '</span>' +
            '<button class="return-label-popup-close" data-action="close-result">&times;</button>' +
          '</div>' +
          '<div class="return-label-popup-body">' +
            '<p>' + message + '</p>' +
          '</div>' +
          '<div class="return-label-popup-footer">' +
            '<button class="return-label-popup-btn return-label-popup-btn-yes" data-action="close-result">OK</button>' +
          '</div>' +
        '</div>'
      );

      jQuery("body").append($overlay).append($popup);

      function closeResult() {
        $overlay.remove();
        $popup.remove();
        if (isSuccess) {
          window.location.reload();
        }
      }

      $overlay.on("click", closeResult);
      $popup.on("click", '[data-action="close-result"]', closeResult);
    },
    getContext: _.wrap(
      TransactionLineViewsCellActionableView.prototype.getContext,
      function (fn) {
        var originalRet = fn.apply(this, _.toArray(arguments).slice(1));

        originalRet.rentalEndDate = this.rentalEndDate;
        originalRet.isRental = this.isRental;
        originalRet.isRentalExpired = this.isRentalExpired;
        originalRet.onRent = this.status === "3" && !this.hasOpenRma && !this.replacementRequest;
        originalRet.hasOpenRma = this.hasOpenRma;
        originalRet.rmaDetails = this.rmaDetails;
        originalRet.replacementRequest = this.replacementRequest;
        originalRet.canCreateLabel = this.enableLabelCreation;
        originalRet.downloadFileUrl = this.downloadFileUrl;
        originalRet.notifyLostTool = this.notifyLostTool;
        originalRet.lostTool = this.lostTool;
        originalRet.isRentalClosed = this.isRentalClosed;

        originalRet.rentalExpiredMessage = this.isRentalExpired
          ? "This rental period has ended. The invoice will be renewed automatically on a monthly basis."
          : null;

        return originalRet;
      }
    ),
  });
});
